import { createAction } from 'redux-actions'

export const INIT_SAGAS = createAction('INIT_SAGAS')
export const INIT_SAGAS_START = createAction('INIT_SAGAS_START')
export const INIT_SAGAS_ERROR = createAction('INIT_SAGAS_ERROR')
export const INIT_SAGAS_FINALLY = createAction('INIT_SAGAS_FINALLY')
